<template>
  <div class="html-content">
    <h2>Доставка и возврат</h2>
    <div v-html="GET_FRAGMENT('product_delivery')" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'delivery',

    computed: {
      ...mapGetters({
        GET_FRAGMENT: 'staticPages/fragments'
      })
    },
  }
</script>